import React, { useEffect } from 'react'
import LoadingSpinner from '../CommonComponents/loadingSpinner'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { LEFT_SIDE_BAR_SELECTED } from '../PartnerPortal/leftNavbar';
import { constructSelectedComponent } from '../../Factory/factory';
import { PAYOUTS_COMPONENT } from '../Payouts/payoutsWrapper';
import { getPartnerDetails } from '../../Actions/partnerDetailsAction';
import { getPaypalIdentity } from '../../Actions/paypalIdentityAction';
import { connectPaypalIdentity } from '../../Actions/paypalConnectIdentityAction';

const PaypalLoginReturnWrapper = () => {
  const identity = useSelector(state => state.paypalIdentity);
  const identityConnected = useSelector(state => state.paypalIdentityConnected);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    dispatch(getPartnerDetails());
    dispatch(getPaypalIdentity());
    connect();
  }, [])


  useEffect(() => {
    if(identity !== null) {
      redirect();
    }
  }, [identity])

  useEffect(() => {
    if(identityConnected !== null) {
      redirect();
    }
  }, [identityConnected]);

  const redirect = () => {
    dispatch({
      type: LEFT_SIDE_BAR_SELECTED,
      payload: constructSelectedComponent(PAYOUTS_COMPONENT),
    });
    history.replace({pathname: "/partner-portal"});
  };

  const connect = () => {
    const queryParams = new URLSearchParams(location.search);
    if (
        queryParams.has("code") 
    ) {
        dispatch(connectPaypalIdentity(queryParams.get("code")));
        history.replace({
            search: "",
        });
    } else {
      redirect();
    }
  }

  return (
    <div className='paypalReturnContainer'>
      <LoadingSpinner target={'paypalReturnContainer'}/>;
    </div>
  )
}

export default PaypalLoginReturnWrapper